<template>
  <div>
    <el-tooltip trigger="hover"
                placement="top-start"
                :content="mapFun(state,stateList)">
      <StateDot :state="state"/>
    </el-tooltip>

  </div>
</template>

<script>
export default {
  props: {
    state: String
  },
  data() {
    return {
      stateList: [{
        label: '投放中',
        value: 'enabled'
      },
      {
        label: '已暂停',
        value: 'paused'
      },
      {
        label: '已存档',
        value: 'archived'
      }],
    }
  },

  mounted() {

  },

  methods: {
    mapFun(index, arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].value === index) {
          return arr[i].label
        }
      }
    },
  }
}
</script>

<style scoped lang='less'>

</style>
